import status from "@store/store.status";
import statusMotivo from "@store/store.statusMotivo";
import estadoCivil from "@store/store.estadoCivil";
import sexos from "@store/store.sexos";
import estado from "@store/store.estado";
import cidade from "@store/store.cidade";
import login from "@store/store.login";
import contratos from "@store/store.contratos";
import cobrancas from "@store/store.cobrancas";
import layout from "@store/store.layout";
import entidades from "@store/store.entidades";
import parceiros from "@store/store.parceiros";
import beneficiarios from "@store/store.beneficiarios";
import formaPagamento from "@store/store.associacao";
import associacao from "@store/store.formaPagamento";
import usuarios from "@store/store.usuarios";
import tipo_usuario from "@store/store.tipo_usuario";
import especieBeneficio from "@store/store.especieBeneficio";
import porcentagemDesconto from "@store/store.porcentagemDesconto";
import tipoContrato from "@store/store.tipoContrato";
import produto from "@store/store.produto";
import termos from "@store/store.termos";

const actions = {
  ...status.actions,
  ...statusMotivo.actions,
  ...estadoCivil.actions,
  ...sexos.actions,
  ...estado.actions,
  ...cidade.actions,
  ...contratos.actions,
  ...cobrancas.actions,
  ...entidades.actions,
  ...parceiros.actions,
  ...beneficiarios.actions,
  ...formaPagamento.actions,
  ...associacao.actions,
  ...usuarios.actions,
  ...tipo_usuario.actions,
  ...especieBeneficio.actions,
  ...porcentagemDesconto.actions,
  ...tipoContrato.actions,
  ...produto.actions,
  ...login.actions,
  ...layout.actions,
  ...termos.actions
};

export default actions;
